<template>
  <FullPage>
    <Webview>
      <Header title="輸入驗證碼" :back="back"></Header>
      <div class="logo_frame _fill">
        <div class="logo"><img src="@img/logo_bg.svg" alt=""></div>
        <div class="content">
          系統已將驗證碼寄至<br>
          {{email}}
        </div>
        <div class="otp_ctn">
          <OtpInput v-model="otp" :isValid="isValid" :submit="submit_self" @enter="submit_self" />
          <div class="text">請輸入六位驗證碼</div>
        </div>
      </div>

      <Version />
      <div class="wv_button">
        <div class="main_btn _main" @click="submit_self">{{$tp("label.ok")}}</div>
      </div>
    </Webview>
  </FullPage>
</template>

<script>
const verifyOtpLength = 6;

export default {
  props: {
    email: String,
    back: Function,
    submit: Function,
  },
  computed: {
    verifyOtpLength: () => verifyOtpLength,
  },
  data() {
    return {
      otp: "",
      //otp
      isValid: true,
    };
  },
  methods: {
    submit_self() {
      this.isValid = true;

      if (!this.otp || this.otp.length !== verifyOtpLength) {
        this.isValid = false;
        return MESSAGE("e", this.$tp("please.enter", { label: this.$tp("label.otp") }));
      }

      this.submit(this.otp);
    },
  },
}
</script>

<style lang="scss">
div.logo_frame div.otp_ctn {
  // div.vue-otp-input {
  //   margin: 0 auto;
  //   margin-top: 2.5rem;

  //   @media (max-height: 440px) {
  //     margin-top: 1.5rem;
  //   }

  //   input.otp-input {
  //     font-size: 20px;
  //     background-color: #ffffff;
  //     color: $main;
  //     border: 1px solid $gray_40;
  //     width: 2rem;
  //     height: 2rem;
  //     font-size: 1.2rem;
  //     padding-bottom: 0.2rem;
  //     &::placeholder {
  //       opacity: 0;
  //     }
  //     &.defualt-error-input-separate {
  //       border-color: red;
  //     }

  //     @media (max-width: 320px) {
  //       width: 1.5rem;
  //       height: 1.5rem;
  //       font-size: 1rem;
  //     }
  //   }
  // }

  .text {
    text-align: center;
    color: $gray_60;
    font-size: 60%;
    margin-top: 0.6rem;
  }
}
</style>